<template>
    <div class="page-content" id="ppes-form">
        <Titlebar :backPath="'/parameters/ppes'" :incrustation="'fa-shield'">
            <h1 v-if="!editMode"><span>{{ $t('ppes.titles.new') }}</span> <span v-if="nameList">"</span><span
                    style="font-weight: 900">{{ nameList
                }}</span><span v-if="nameList">"</span></h1>
            <h1 v-if="editMode">{{ nameList }}</h1>
        </Titlebar>
        <div class="row justify-content-center full-height">
            <div class="col-6">
                <UiCard>
                    <form class="form p-0">
                        <h2><i class="fa fa-list"></i>{{ $t('ppes.phonebook') }}</h2>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('ppes.cols.list') }}</label>
                            <input class="form-input col" type="text" id="nameList" name="nameList" v-model="nameList" :class="{invalid:errors.has('nameList')}" v-validate
                                    :data-vv-rules="'required'" data-vv-validate-on="none"
                                    :data-vv-as="$t('ppes.cols.name')"/>
                            <span class="form-input-error" v-show="showErrors['nameList'] && errors.has('nameList')"
                                    @click="hideError('nameList')">{{ errors.first('nameList') }}</span>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">
                                {{ $t('ppes.cols.mode') }}
                                <span style="position: relative;margin-left: 10px;">
                                        <i class="fa fa-question-circle text-warning warning-beepiz-remote-monitoring show"></i>
                                        <div class="tooltip left" style="width: 250px;top: -2px; left: 37px;">
                                            <h5 style="color:#ffc107; font-weight:700">{{ $t('ppes.tooltip.title') }}</h5>
                                            {{ $t('ppes.tooltip.content', {univers: Utils().getApplicationName()}) }}
                                        </div>
                                </span>
                            </label>
                            <div class="col">
                                <UiSwitch
                                    v-model="modeListBool" 
                                    :labelYes="$t('ppes.verification.all')" 
                                    :labelNo="$t('ppes.verification.missing')" 
                                />
                            </div>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('ppes.form.notification') }}</label>
                            <div class="col-8 simple-checkbox">
                                <input :false-value="0" :true-value="1" id="notification" type="checkbox"
                                        v-model="notificationList"/>
                                <label for="notification">{{ $t('ppes.verification.mailInfo') }}</label>
                            </div>
                        </div>
                    </form>
                </UiCard>
            </div>
            <div class="col-6 col-xl-6 full-height">
                <UiCard>
                    <form class="form full-height ppes-selection p-0">
                        <h2><i class="fa fa-shield"></i>{{ $t('ppes.contacts') }}</h2>
                        <div class="selected-ppes">
                            <h3>{{ $t('ppes.selected') }} <span class="badge" v-if="itemsList.length > 0">{{ itemsList.length }}</span></h3>
                            <draggable :element="'div'" :list="itemsList" :options="draggableOptions"
                                        class="ppes-inner"
                                        v-if="itemsList && itemsList.length > 0">
                                <div class="ppe-item" v-for="(item,index) in itemsList">

                                    <span :class="['ppe'+item.id]" class="ppe"></span>
                                    <span class="ppe-label">{{ item.name }}</span>
                                    <i class="fa fa-arrows-v"></i>
                                    <i @click="removeItem(index)" class="fa fa-times"></i>
                                </div>
                            </draggable>
                            <div v-else class="no-item">
                                {{ $t('ppes.form.noPpes') }}
                            </div>
                        </div>
                        <div class="unselected-ppes">
                            <h3>{{ $t('ppes.unselected') }}</h3>
                            <div class="ppes-inner">
                                <span @click="addItem(item)" class="ppe-item" v-for="item in unselectedItems">
                                    <span :class="['ppe'+item.id]" class="ppe"></span>
                                    <span class="add-placeholder"><i class="fa fa-plus"></i></span>
                                    <div class="tooltip bottom">{{ item.name }}</div>
                                </span>
                            </div>
                        </div>
                    </form>
                </UiCard>
            </div>
        </div>
        <Toolbar class="justify-content-end">
            <Btn>
                <router-link tag="span" to="/parameters/ppes">{{ $t('global.cancel') }}</router-link>
            </Btn>
            <Btn class="primary" @click.native.stop="validForm()" v-can="'beepiz-edit-ppes'">
                {{ $t('global.save') }}
            </Btn>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Utils from '@/services/utils.js';
    import FormUtils from '@/services/form.js';
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import UiSwitch from "@/components/ui/Switch";
    import SuperTable from "@/components/ui/Table";
    import draggable from 'vuedraggable';

    import _filter from 'lodash/filter'
    import _find from 'lodash/find'
    import _flatMap from 'lodash/flatMap'
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PpesForm',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            UiSwitch,
            SuperTable,
            draggable
        },
        computed: {

            selectedItems() {
                return this.itemsList
            },

            unselectedItems() {
                return _filter(this.items, item => {
                    return !_find(this.itemsList, {id: item.id})
                })
            },
            draggableOptions() {
                return {
                    handle: '.fa-arrows-v'
                }
            },
        },
        data: () => ({
                listId: null,
                nameList: "",
                modeListBool: true,
                itemsList: [],
                notificationList: 0,
                editMode: false,
                items: [],
                itemsChanged: false,
                showErrors: {
                    nameList: false
                }

            }
        ),
        methods: {
          Utils() {
            return Utils
          },

            validForm: function () {

                FormUtils.hideAllErrors(this);

                this.$validator.validateAll().then(() => {

                    window.Vfc.$refs.loading.show();
                    var objToEdit = {
                        name: this.nameList,
                        mode: this.modeListBool ? 1 : 0,
                        mailNotification: this.notificationList
                    };
                    if (this.editMode) {

                        if (this.itemsChanged) {
                            objToEdit.ppes = _flatMap(this.itemsList, item => {
                                return item.id
                            })
                        }

                        axios.put(API.route(API.endpoints.ppes.edit, {id: this.listId}), objToEdit)
                            .then(response => {
                                window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                                window.Vfc.$refs.loading.hide();
                            })
                            .catch(error => {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                                window.Vfc.$refs.loading.hide();
                            })
                    } else {

                        objToEdit.ppes = _flatMap(this.itemsList, item => {
                            return item.id
                        })

                        axios.post(API.endpoints.ppes.add, objToEdit)
                            .then(response => {
                                window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                                window.V._router.replace('/parameters/ppes/' + response.data.message, () => {
                                    this.loadData();
                                });
                            })
                            .catch(error => {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                                window.Vfc.$refs.loading.hide();
                            })
                    }
                })
                    .catch(() => {
                        this.showAllErrors();
                        window.Vfc.$refs.loading.hide();
                    })
            },

            hideError: function (key) {
                FormUtils.hideError(this, key);
            },

            showAllErrors: function () {
                for (var showError in this.showErrors) {
                    this.showErrors[showError] = true;
                }
            },

            loadItems() {
                return axios.get(API.endpoints.ppes.items)
                    .then(responseItems => {

                        this.items = responseItems.data
                    })
            },

            loadData: function (contactsOnly) {
                this.listId = this.$route.params.id;
                if (this.listId) {
                    this.editMode = true;
                }
                window.Vfc.$refs.loading.show();
                this.loadItems()
                    .then(responseItems => {

                        axios.get(API.route(API.endpoints.ppes.show, {id: this.listId}))
                            .then(response => {
                                this.nameList = response.data.name;
                                this.modeListBool = response.data.mode == 1
                                this.notificationList = response.data.mailNotification
                                this.itemsList = response.data.ppes
                                if (this.$route.meta.specialAction == 'copy') {
                                    this.editMode = false;
                                    this.listId = null;
                                    this.nameList += ' (copie)';
                                }

                                window.Vfc.$refs.loading.hide();
                            })
                    })
            },

            removeItem(itemIndex) {
                this.itemsList.splice(itemIndex, 1)
            },

            addItem(item) {
                this.itemsList.push(item)
            }
        },
        created() {

        },
        mounted() {
            if (!useDvFlagAccess('beepiz-ppe-list-can:create')){
              this.$router.push({ name: 'AccessDenied', params: { slug: "ppes_no_role"} })
            }
            this.listId = this.$route.params.id;
            if (this.listId) {
                this.editMode = true;
                this.loadData();
            } else {
                this.loadItems()
                    .then(response => {
                        window.Vfc.$refs.loading.hide();
                    })

            }

        },
        watch: {
            itemsList(newVal, oldVal){
                if(oldVal.length > 0){
                    this.itemsChanged = true
                }
            }
        }
    }
</script>

<style lang="scss">


</style>
